export type TransferAction = 'move' | 'copy';

export type PendingOp = {
  id: string; // `${contentId}:${targetAlbumId}`
  contentId: number;
  sourceAlbumId: number;
  targetAlbumId: number;
  action: TransferAction;
};

export const opId = (contentId: number, targetAlbumId: number) =>
  `${contentId}:${targetAlbumId}`;
